<template>
<div class="col-12">
  <div class="row">
    <div class="col-2 col-md-2 text-left">
      <div class="form-group">
        <br />
        <label>From (RS - Start Date)</label>
        <flat-pickr class="form-control" v-model="filter.startDate"></flat-pickr>
      </div>
      <div class="form-group">
        <label>To (RS - Start Date)</label>
        <flat-pickr class="form-control" v-model="filter.toDate"></flat-pickr>
      </div>
      <div class="form-group">
        <input type="checkbox" class="form-control" v-model="filterLocation" id="filter-location">
        <label>Filter Location</label>
        <app-google-place-autocomplete v-if="filterLocation" v-on:placeChanged="placeChanged" :placeName="place.name"></app-google-place-autocomplete>
      </div>
      <button type="button" class="btn btn-outline-secondary" @click="search">Filter <i class="fas fa-search"></i></button>

      <hr/>

      <div id="report-table">
        <h5> Transaction Status  </h5>
        <table class="table table-bordered table-hover table-sm">
          <thead>
            <tr>
              <th scope="col">Status</th>
              <th scope="col">Percentage</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list,index) in percentage" v-bind:key="index">
              <td>{{list.transactionStatus}}</td>
              <td>{{list.percent}}</td>
            </tr>
          </tbody>
        </table>
        <h6>Count of all Trasaction : {{this.totalCount}}</h6>
      </div>



    </div>
    <div class="col-10 col-md-10">
      <app-google-maps :places="requestSamplePlaces"></app-google-maps>
    </div>
    <br />
    <app-datatable :type="'view'" :elements="dtElements" :collections="rs" ></app-datatable>
    <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
  </div>
</div>
</template>

<script>
import AppDatatable from '../components/AppDatatable.vue'
import AppDataPagination from '../components/AppDataPagination.vue'
import AppGoogleMaps from '../components/AppGoogleMaps.vue'
import AppGooglePlaceAutocomplete from '../components/AppGooglePlaceAutocomplete.vue'
import api from '../services/api'
import moment from 'moment'

export default {
  components: {
    AppGoogleMaps, AppDatatable, AppDataPagination, AppGooglePlaceAutocomplete
  },
  data() {
    return {
      filter: {
        startDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD')
      },
      place: {
        id: '',
        name: ''
      },
      percentage: '',
      totalCount: '',
      filterLocation: false,
      selectedId: '',
      searchKey: '',
      pagination: {
        pageSize: 10,
        currentPage: 1
      },
      rs: [],
      requestSamplePlaces: [],
      dtElements: [
        {
          title: 'SR Number',
          column: 'srNumber',
          type: 'text',
          width: 3
        },
        {
          title: 'Start Date',
          column: 'startDate',
          type: 'date'
        },
        {
          title: 'Product',
          column: 'product',
          type: 'text'
        },
        {
          title: 'Customer',
          column: 'customer',
          type: 'text'
        },
        {
          title: 'Qty',
          column: 'qty',
          type: 'number'
        },
        {
          title: 'UOM',
          column: 'UOM',
          type: 'text'
        },
      ],
    }
  },
  watch: {
    filterLocation() {
      if(!this.filterLocation) {
        this.place.id = ''
        this.place.name = ''
      }
    }
  },
  async created() {
    this.filterData()
  },
  methods: {
    search() {
      this.filterData()
    },
    async filterData() {
      const dashboardApi = api('dashboard/request-sample-places')
      const dashboardDetailApi = api('dashboard/request-sample-partial')
      const dashboardPercentageApi = api('dashboard/request-sample-percentage')
      const dashboardCountTransaction = api('dashboard/request-sample-total-transaction')
      const query = {
        params: {
          startDate: this.filter.startDate,
          toDate: this.filter.toDate,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          placeId: this.place.id
        }
      }
      const places = await dashboardApi.get()
      this.requestSamplePlaces = [...places]

      const detail = await dashboardDetailApi.getWithQuery(query)
      this.rs = detail

      const percentage = await dashboardPercentageApi.getWithQuery(query)
      this.percentage = percentage

      const totalCount = await dashboardCountTransaction.get()
      this.totalCount = totalCount[0].totalTransaction
    },
    placeChanged(placeDetail) {
      this.place.id = placeDetail.place_id
      this.place.name = placeDetail.formatted_address
    },
    changePage(payload) {
      this.pagination = payload
      this.filterData()
    },
  }
  // selectRow(id) {
  //   this.selectedId = id
  // },    
}
</script>